module.exports = __webpack_public_path__ + "static/media/hall-sph706-2.8e074dff.svg";